exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Bell-module__bell___1lkWJ{grid-column:2;grid-row:1;height:230px;width:100%;background-color:hsla(0,0%,100%,.4);border-radius:10px;display:flex;justify-content:center;align-items:center;transition:all .2s ease-in-out;position:relative;z-index:-1}@media screen and (min-width:1200px){.Bell-module__bell___1lkWJ{width:305px}}.Bell-module__bell___1lkWJ svg{color:#fff;font-size:60px}", ""]);

// exports
exports.locals = {
	"bell": "Bell-module__bell___1lkWJ"
};